module.exports = __webpack_public_path__ + "img/cl_five_steps_5.41d9a48e.png";